module.exports = __webpack_public_path__ + "static/img/hamburg-innovation.ce6e6466.png";